// extracted by mini-css-extract-plugin
export default {"container":"Radios_container__r6nmW","radio":"Radios_radio__ux2wr"};